module.exports = __webpack_public_path__ + "static/img/video.9ca79f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/grid/video.png
// module id = TNHt
// module chunks = 3